import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNotebook: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconNotebook"><Path d="M3.5 21.5V2.5H7V21.5H3.5Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M8.5 21.5H20.5V2.5H8.5V21.5ZM12 7V8.5H17V7H12ZM12 11V12.5H17V11H12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconNotebook;
